<div class="premium-discount-elevated" *ngIf="elevatedPeriods">
  <eds-section-header
    [title]="'products.premium-discount-elevated-title' | translate"
    [level]="6"
    caveatPlacement="PremiumDiscountElevated"
    edsSpacing="md"
  ></eds-section-header>

  <eds-proximal placement="PremiumDiscountElevatedTop"></eds-proximal>

  <table class="table table--secondary">
    <thead class="table__thead">
      <tr class="table__tr">
        <th class="table__th">
          <span class="small"
            >{{ "products.premium-discount-elevated-end-date" | translate
            }}<eds-footnote
              placement="PremiumDiscountElevatedEndDate"
            ></eds-footnote
          ></span>
        </th>
        <th class="table__th">
          <span class="small"
            >{{ "products.premium-discount-elevated-trading-days" | translate
            }}<eds-footnote
              placement="PremiumDiscountElevatedTradingDays"
            ></eds-footnote
          ></span>
        </th>
        <th class="table__th">
          <span class="small"
            >{{ "products.premium-discount-elevated-reason" | translate
            }}<eds-footnote
              placement="PremiumDiscountElevatedDiscountReason"
            ></eds-footnote
          ></span>
        </th>
      </tr>
    </thead>
    <tbody class="table__body">
      <tr class="table__tr" *ngFor="let period of elevatedPeriods">
        <td class="table__td">
          {{ period.endDate }}
        </td>
        <td class="table__td">
          {{ period.tradingDays }}
        </td>
        <td class="table__td">
          {{ period.reason }}
          <eds-icon
            *ngIf="period.reasonTooltip"
            edsTooltip
            [analyticsName]="period.reason"
            [tooltipContent]="period.reasonTooltip"
            type="info"
            size="small"
          ></eds-icon>
        </td>
      </tr>
    </tbody>
  </table>

  <eds-proximal placement="PremiumDiscountElevatedBottom"></eds-proximal>
</div>
